import './App.css';
import MenuDrawerApp from './Componentes/MenuDrawerApp';
import { BrowserRouter as Router, Link, Route, Routes } from 'react-router-dom'
import Home from './Componentes/Home';
import MenuTorneos from './Componentes/MenuTorneos';
import ErrorPage from './Componentes/ErrorPage';
import Politicas from './Componentes/Politicas';
import './App.css';
import { ThemeProvider } from '@mui/material';
import React from 'react';
import { createTheme } from '@mui/material';
const theme = createTheme({
  palette: {
    primary: {
      main: '#28855E',
    },
  },
});

function App(props) {
  return (
    <div className="App">
      <ThemeProvider theme={theme}>
        <React.StrictMode>
          <ContenidoApp />
        </React.StrictMode>
      </ThemeProvider>
    </div>
  );
}

export default App;


function ContenidoApp() {
  return (
    <div className="App">
      <Router>
        <Routes>
          <Route path='/' element={<MenuDrawerApp contenido={<Home titulo={"JChess Manager"}/>}/>}></Route>
          <Route path='/t/' element={<MenuDrawerApp contenido={<MenuTorneos titulo={"Torneos"}/>} />}></Route>
          <Route path='/t/:id' element={<MenuDrawerApp contenido={<MenuTorneos titulo={"Torneos"}/>} />}></Route>
          <Route path='/politicas/' element={<MenuDrawerApp contenido={<Politicas titulo={"Politicas"}/>} />}></Route>
          <Route path='*' element={<MenuDrawerApp contenido={<ErrorPage titulo={"No encontrado"}/>} />}></Route>

        </Routes>
      </Router>
    </div>
  );
}